import React from 'react';
import { ResultItemProps } from 'components/ui/Results/ResultItem';
import ResultImage from 'shared/components/hawksearch/components/ui/Results/ResultImage';
// #region HCL
import { formatDate } from '../../hcl/dateUtils';
// #endregion

function ResultItem({ item }: ResultItemProps) {
	const itemName = item.getDocumentValue('name');
	const url = item.getDocumentValue('url_detail');
	// #region HCL
	const postDate = formatDate(item.getDocumentValue('post_date'));
	// #endregion
	return (
		<div className="uabb-blog-posts-col-2 uabb-post-wrapper">
			<div className="uabb-blog-posts-shadow clearfix">
				<div className="uabb-blog-post-inner-wrap uabb-thumbnail-position-top uabb-empty-img">
					<div className="uabb-blog-post-content">
						<ResultImage item={item} />
						<h2 className="uabb-post-heading uabb-blog-post-section">
							{url ? (
								<a href={url}>
									<span>{itemName}</span>
								</a>
							) : (
								<span>{itemName}</span>
							)}
						</h2>
						{postDate && (
							<p className="uabb-post-meta uabb-blog-post-section">
								<span className="uabb-meta-date">{postDate}</span>
							</p>
						)}
						<div
							className="uabb-blog-posts-description uabb-blog-post-section uabb-text-editor"
							dangerouslySetInnerHTML={{ __html: item.BestFragment }}
						/>

						{url && (
							<a className="roc-btn roc-btn-secondary result-item__btn" href={url}>
								<span>Read More...</span>
							</a>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default ResultItem;
